import { useState } from 'react';
import { Search, Eye, Building2, Trash2 } from 'lucide-react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const BusinessManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const mockBusinesses = [
    {
      id: 1,
      name: 'Café del Centro',
      category: 'Restaurantes',
      owner: 'Ana López',
      email: 'contacto@cafedelcentro.com',
      phone: '+57 312 345 6789',
      registrationDate: '2025-12-10',
      address: 'Carrera 7 #15-32, Bogotá'
    },
    {
      id: 2,
      name: 'Tienda Tech Solutions',
      category: 'Tecnología',
      owner: 'Pedro Sánchez',
      email: 'info@techsolutions.com',
      phone: '+57 301 234 5678',
      registrationDate: '2025-11-25',
      address: 'Calle 100 #19-45, Medellín'
    },
    {
      id: 3,
      name: 'Gym Fitness Pro',
      category: 'Deportes',
      owner: 'Laura Ramírez',
      email: 'gym@fitnesspro.com',
      phone: '+57 315 678 9012',
      registrationDate: '2025-12-05',
      address: 'Avenida 68 #45-23, Cali'
    }
  ];

  const handleDelete = (businessId) => {
    console.log('Delete business:', businessId);
  };

  const handleViewDetails = (businessId) => {
    console.log('View details:', businessId);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground mb-2">
          Gestión de Empresas
        </h1>
        <p className="text-muted-foreground">
          Gestiona y administra las empresas registradas en la plataforma
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="text"
            placeholder="Buscar por nombre, categoría o propietario..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full"
            leftIcon={<Search className="w-4 h-4 text-muted-foreground" />}
          />
        </div>
        <Select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e?.target?.value)}
          className="w-full sm:w-48"
        >
          <option value="all">Todas las Categorías</option>
          <option value="restaurantes">Restaurantes</option>
          <option value="tecnologia">Tecnología</option>
          <option value="deportes">Deportes</option>
        </Select>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {mockBusinesses?.map((business) => {
          return (
            <div key={business?.id} className="bg-card rounded-lg border shadow-sm p-6">
              <div className="flex items-start justify-between">
                <div className="flex gap-4 flex-1">
                  <div className="w-16 h-16 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Building2 className="w-8 h-8 text-primary" />
                  </div>

                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="text-lg font-semibold text-foreground">
                          {business?.name}
                        </h3>
                        <p className="text-sm text-muted-foreground">{business?.category}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Propietario</p>
                        <p className="text-sm font-medium text-foreground">{business?.owner}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Email</p>
                        <p className="text-sm font-medium text-foreground">{business?.email}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Teléfono</p>
                        <p className="text-sm font-medium text-foreground">{business?.phone}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Fecha de Registro</p>
                        <p className="text-sm font-medium text-foreground">{business?.registrationDate}</p>
                      </div>
                    </div>

                    <div className="mb-4">
                      <p className="text-xs text-muted-foreground mb-1">Dirección</p>
                      <p className="text-sm font-medium text-foreground">{business?.address}</p>
                    </div>

                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="outline"
                        iconName="Eye"
                        onClick={() => handleViewDetails(business?.id)}
                      >
                        Ver Detalles
                      </Button>

                      <Button
                        size="sm"
                        variant="danger"
                        iconName="Trash2"
                        onClick={() => handleDelete(business?.id)}
                      >
                        Eliminar
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BusinessManagement;